import { createReducer, on } from "@ngrx/store";
import { iEntrada, mEntrada } from "../../entrada/entrada.interface";
import { IEntradas, IEntradasInitState } from "../../interfaces/entradas";
import { IFormState, InitialFormState } from "../../interfaces/forms";
import {
  guardarFormularios,
  guardarFormulariosFailure,
  guardarFormulariosSuccess,
  guardarNuevoTema,
  resetForms,
  validarFormularios,
} from "./actions";

export const initialState: IFormState = InitialFormState;

export const validateFormReducer = createReducer(
  initialState,
  on(validarFormularios, (state) => {
    return { ...state, validar: true };
  }),
  on(guardarFormularios, (state) => ({
    ...state,
    validar: false,
    guardando: true,
  })),
  on(guardarFormulariosSuccess, (state, { response }) => ({
    ...state,
    guardando: false,
    response,
  })),
  on(guardarFormulariosFailure, (state, { error }) => ({
    ...state,
    guardando: false,
    error,
  })),
  on(guardarNuevoTema, (state, { temas, acuerdoActual }) => ({
    ...state,
    guardando: false,
    error: null,
    response: {
      temas,
      acuerdoActual,
    },
  })),
  on(guardarNuevoTema, (state, { temas, acuerdoActual }) => ({
    ...state,
    guardando: false,
    error: null,
    response: {
      temas,
      acuerdoActual,
    },
  })),
  on(resetForms, (state, payload) => {
    return initialState;
  })
);
